import axios, { AxiosError } from 'axios';
import axiosRetry, { linearDelay } from 'axios-retry';
import store from '../store';
import { getLoginUser } from '../store/selectors/user';

const addUserIdToQuery = (config) => {
  const state = store.getState();
  const currentUser = getLoginUser(state);
  const userEmail = currentUser?.email;

  const apiDomains = [
    process.env.REACT_APP_API_BASE_DOMAIN,
    process.env.REACT_APP_API_OPTIMISE_DOMAIN,
  ];
  const isApiDomain = apiDomains.includes(config.baseURL);

  if (userEmail && isApiDomain) {
    const emailPrefix = userEmail.split('@')[0];
    const url = new URL(config.url, config.baseURL);
    url.searchParams.set('userId', emailPrefix);
    config.url = url.pathname + url.search;
  }

  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_DOMAIN,
  withCredentials: true,
  transformResponse: axios.defaults.transformResponse.concat(
    (params) => params.data || params
  ),
});

const optimiseApi = axios.create({
  baseURL: process.env.REACT_APP_API_OPTIMISE_DOMAIN,
  withCredentials: true,
  transformResponse: axios.defaults.transformResponse.concat(
    (params) => params.data || params
  ),
});

// Add request interceptor to include userId as query parameter
api.interceptors.request.use(addUserIdToQuery);

optimiseApi.interceptors.request.use(addUserIdToQuery);

// Axios-retry - it is an additional solution to retry failed requests
// with random 429 and 502 errors from GCP load balancer
const retryConfig = {
  retries: 2,
  retryCondition: (error) =>
    error?.config?.withRetry &&
    (error.response?.status === 429 ||
      error.response?.status === 502 ||
      error.code === AxiosError.ERR_NETWORK),
  retryDelay: linearDelay(),
};

axiosRetry(api, retryConfig);
axiosRetry(optimiseApi, retryConfig);

const errorResponseTransformer = (error) => {
  if (error.response?.data) {
    const transformedData = error.response.data.error || error.response.data;
    error.error = transformedData;
  }
  return Promise.reject(error);
};

api.interceptors.response.use((response) => response, errorResponseTransformer);

optimiseApi.interceptors.response.use(
  (response) => response,
  errorResponseTransformer
);

export default api;
export { optimiseApi };
